import * as React from 'react';
import { cn } from './cn';

export const TooltipProvider = ({ children }: { children: React.ReactNode }) => children;
export const Tooltip = ({ children }: { children: React.ReactNode }) => children;
export const TooltipTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { asChild?: boolean }
>(({ className, asChild: _asChild, ...props }, ref) => (
  <button ref={ref} className={cn('inline-flex', className)} {...props} />
));
export const TooltipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { side?: string; sideOffset?: number }
>(({ className, side: _side, sideOffset: _sideOffset, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md transition-opacity',
      className,
    )}
    {...props}
  />
));
